import React, { type JSX } from 'react';
import { type SelectListItem } from '@resources/js/typings/viewModels/selectListItemViewModel';
import VerticalContent from '@resources/js/components/VerticalContent/VerticalContent';
import TabbedSelect from '@resources/js/components/TabbedSelect/TabbedSelect';
import TabbedSelectLinkOptionWrapper from '../TabbedSelectLinkOptionWrapper/TabbedSelectLinkOptionWrapper';
import Select from '@resources/js/components/Select/Select';
import SelectLinkOptionWrapper from '../SelectLinkOptionWrapper/SelectLinkOptionWrapper';
import HorizontalContent from '@resources/js/components/HorizontalContent/HorizontalContent';

export type BuildsZonePageFilterProps = {
  roleLabel: string;
  roleOptions: SelectListItem<string>[];
  selectedRole: string | null;
  zoneTypeLabel: string;
  zoneBackgroundUrl: string;
  zoneTypeOptions: SelectListItem<string>[];
  selectedZoneType: string;
  showDifficultySelect: boolean;
  difficultyLabel: string;
  difficultyOptions: SelectListItem<string>[];
  selectedDifficulty: string;
  encounterLabel: string;
  encounterOptions: SelectListItem<string>[];
  selectedEncounter: string;
  affixesLabel: string;
  affixesOptions: SelectListItem<string>[];
  selectedAffixes: string;
};

function BuildsZonePageFilter({
  roleLabel,
  roleOptions,
  selectedRole,
  zoneTypeLabel,
  zoneTypeOptions,
  selectedZoneType,
  showDifficultySelect,
  difficultyLabel,
  difficultyOptions,
  selectedDifficulty,
  encounterLabel,
  encounterOptions,
  selectedEncounter,
  affixesLabel,
  affixesOptions,
  selectedAffixes,
}: BuildsZonePageFilterProps): JSX.Element {
  return (
    <HorizontalContent
      gap={'small'}
      className={'horizontal-content--stretch-wrap'}
    >
      <VerticalContent gap={'none'}>
        <label>
          <b>{roleLabel}</b>
        </label>
        <TabbedSelect
          value={
            selectedRole === null
              ? null
              : (roleOptions.find((x) => x.value === selectedRole) ??
                roleOptions[0])
          }
          options={roleOptions}
          OptionWrapper={TabbedSelectLinkOptionWrapper}
          wrapperInheritsProps
        />
      </VerticalContent>
      {zoneTypeOptions.length > 1 && (
        <VerticalContent gap={'none'}>
          <label>
            <b>{zoneTypeLabel}</b>
          </label>
          <TabbedSelect
            value={
              zoneTypeOptions.find((x) => x.value === selectedZoneType) ??
              zoneTypeOptions[0]
            }
            options={zoneTypeOptions}
            OptionWrapper={TabbedSelectLinkOptionWrapper}
            wrapperInheritsProps
          />
        </VerticalContent>
      )}
      {showDifficultySelect && (
        <VerticalContent gap={'none'}>
          <label>
            <b>{difficultyLabel}</b>
          </label>
          <Select
            value={
              difficultyOptions.find((x) => x.value === selectedDifficulty) ??
              difficultyOptions[0]
            }
            options={difficultyOptions}
            OptionWrapper={SelectLinkOptionWrapper}
            borderLevel={2}
            aria-label={difficultyLabel}
            inputId='difficulty-select'
            usesEnhancedMarkdown={true}
          />
        </VerticalContent>
      )}
      {encounterOptions.length > 1 && (
        <VerticalContent gap={'none'}>
          <label>
            <b>{encounterLabel}</b>
          </label>
          <Select
            value={
              encounterOptions.find((x) => x.value === selectedEncounter) ??
              encounterOptions[0]
            }
            options={encounterOptions}
            OptionWrapper={SelectLinkOptionWrapper}
            usesEnhancedMarkdown
            borderLevel={2}
            aria-label={encounterLabel}
            inputId='encounter-select'
          />
        </VerticalContent>
      )}
      {affixesOptions.length > 1 && (
        <VerticalContent gap={'none'}>
          <label>
            <b>{affixesLabel}</b>
          </label>
          <Select
            value={
              affixesOptions.find((x) => x.value === selectedAffixes) ??
              affixesOptions[0]
            }
            options={affixesOptions}
            usesEnhancedMarkdown
            OptionWrapper={SelectLinkOptionWrapper}
            borderLevel={2}
            aria-label={affixesLabel}
            inputId='affixes-select'
          />
        </VerticalContent>
      )}
    </HorizontalContent>
  );
}

export default BuildsZonePageFilter;
